<template>
    <div class="rewards-retrieved-list">
        <div class="container">

            <LoaderOverlay v-if="loading"/>



            <div v-if="rewards.length > 0" class="filter-buttons d-flex  justify-content-start justify-content-md-center overflow-auto  pt-4">

                <button class="btn  mb-4 mx-2 btn-filter"
                                v-for="timespan in timespans"
                                v-bind:key="timespan.key"
                                :disabled="current_timespan == timespan.key"
                                @click.prevent="current_timespan = timespan.key">
                    {{ timespan.label }}
                </button>
            </div>



            <div class="rewards-retrieved-table" v-if="rewards.length > 0">
                <div class="d-none d-sm-block">
                    <div class="row ">
                      <div class="col-sm-7 heading">{{ __('NOME VANTAGGIO') }}</div>
                      <div class="col-sm-3 heading text-center">{{ __('DATA') }}</div>
                      <div class="col-sm-2 heading text-center">{{ __('PIN VANTAGGIO') }}</div>
                    </div>
                </div>

                <div class="reward-retrieved-item py-4"  v-for="reward in rewardsPaged" v-bind:key="reward.id">
                    <div v-if="env == 'GCP'" class="row">
                        <div class="col-sm-7 order-2 order-sm-1"><h5>{{ reward.rewardName|raw }}</h5></div>
                        <div class="col-sm-3  order-1 order-sm-2 text-center"><small>{{ formatIsoDate(reward.orderDate) }}</small></div>
                        <div class="col-sm-2 order-3 order-sm-3 text-center">
                            <div v-if="reward.voucherCode">
                                <small class="d-sm-none">{{ __('PIN - NEGOZI TIM') }}</small>
                                <div class="reward-code" >{{ reward.voucherCode }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="row">
                      <div class="col-sm-7 order-2 order-sm-1"><h5>{{ reward.Nomeprodotto }}</h5></div>
                      <div class="col-sm-3  order-1 order-sm-2 text-center"><small>{{ formatIsoDate(reward.createdTime) }}</small></div>
                      <div class="col-sm-2 order-3 order-sm-3 text-center">
                        <div v-if="reward.vouchercode">
                          <small class="d-sm-none">{{ __('PIN - NEGOZI TIM') }}</small>
                          <div class="reward-code" >{{ reward.vouchercode }}</div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="text-center w-100 pt-4" v-if="current_page < page_count">
                    <a href="#" class="load-more" @click.prevent="loadMore">
                        <img :src="modulePath('/js/src/assets/images/icon-plus-blue.png')" class="pr-2" alt="">
                        Carica altri</a>
                </div>
            </div>
            <div class="py-5" v-else-if="!loading">
                Nessun vantaggio richiesto.
            </div>
        </div>
    </div>

</template>

<script>

/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';
import LoaderOverlay from './LoaderOverlay.vue'
import $ from 'jquery';
import moment from 'moment';
import 'slick-carousel';


export default {
    name: 'RewardsListRetrieved',
    mixins: [TimPartyMixin],
    components: {LoaderOverlay},
    props: {
        apiUrl: String,
        catalogUrl: String,
    },
    data: function () {
        return {
            loading: false,
            rewards: [],
            env: "",
            timespans: [
                {
                    'key': 1,
                    'label' : 'ULTIMO MESE',
                },
                {
                    'key': 3,
                    'label' : 'ULTIMI 3 MESI',
                },
                {
                    'key': 6,
                    'label' : 'ULTIMI 6 MESI',
                },
                {
                    'key': null,
                    'label' : 'TUTTI',
                }
            ],
            current_timespan: 1,
            current_page: 1,
            rows_per_page: 10,
        };
    },
    mounted: function () {
        this.setApiUrl(this.apiUrl);

        // if(this.access_token)
            this.getRetrievedRewards();

    },
    methods: {
        getRetrievedRewards: function() {
            var self = this;

            var payload = {
                action: 'getRetrievedRewards',
                access_token: this.accessToken,
            };

            self.loading = true;
            this.callApi( payload, function( response){
                self.loading = false;

                if (response.success) {
                  self.env = response.env;
                  if (self.env === "GCP") {
                    self.rewards = response.data;
                  } else {
                    var rewards = [];
                    for(var i in response.items[0].rows){
                      var row = {};
                      for(var j in response.items[0].columnNames){
                        row[ response.items[0].columnNames[j] ] = response.items[0].rows[i][j];
                      }
                      rewards.push(row);
                    }

                    self.rewards = rewards;

                  }
                }
            });
        },

        loadMore: function(){
            if(this.current_page < this.page_count)
                this.current_page++;
        }
    },
    computed:{
         rewardsFiltered: function() {
            var self = this;

            if(this.current_timespan) {
                var filtered = _.filter(this.rewards, function(item) {
                    if (self.env == "GCP") {
                      var diff = moment( ).diff(moment(item.orderDate), 'months');
                    } else {
                      var diff = moment( ).diff(moment(item.createdTime), 'months');
                    }

                    return diff < self.current_timespan;
                } );

                return filtered
            } else {
                return this.rewards;
            }

        },
        rewardsPaged: function() {
            var offset = this.current_page * this.rows_per_page;

            return this.rewardsFiltered.slice(0, offset);
        },
        page_count: function() {
            return Math.ceil( this.rewardsFiltered.length / this.rows_per_page );
        }
    },
    watch: {
        access_token: function( new_val, old_val){
            this.getRetrievedRewards();
        },
        current_timespan: function(new_val, old_val){
            this.current_page = 1;
        }
    }
}
</script>
